export const SITE_ORIGIN =
  (process.env.REACT_APP_SITE_ORIGIN || 'https://cimmple.com').replace(/\/$/, '');

export const DEFAULT_OG_IMAGE = '/images/platform/cimmpleflow-home.png';

export function absoluteUrl(path: string): string {
  if (!path || path === '/') {
    return `${SITE_ORIGIN}/`;
  }
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_ORIGIN}${normalized.replace(/\/$/, '')}`;
}

export function absoluteAsset(path: string): string {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  return `${SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}

export const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Cimmple',
  legalName: 'Cimmplex Innovations LLP',
  alternateName: ['CimmpleFlow', 'CimmplePay', 'CimmpleRx', 'Cimmplex'],
  url: SITE_ORIGIN,
  logo: absoluteAsset('/images/platform/cimmpleflow-home.png'),
  email: 'contact@cimmple.com',
};

export const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Cimmple',
  url: SITE_ORIGIN,
  publisher: {
    '@type': 'Organization',
    name: 'Cimmplex Innovations LLP',
  },
};

export function faqPageJsonLd(faqs: Array<{ q: string; a: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };
}

export function breadcrumbJsonLd(items: Array<{ name: string; path: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: absoluteUrl(item.path),
    })),
  };
}

